import React from 'react'
import { Trans, useTranslation } from 'react-i18next';

const base_url = process.env.REACT_APP_BASE_URL;

const PaymentSuccess = () => {
    const { t } = useTranslation();
    const searchParams = new URLSearchParams(window.location.search);
    const amount = searchParams.get('amount');

    return (
        <div className='payment-success'>
            <img src={`${base_url}/images/accept.png`} alt="" />
            <h1 className="m-3">{t("accomodation.PaymentRequestSuccess")}</h1>
            <Trans>
                {t("accomodation.PaymentRequestSuccessDesc")}
            </Trans>
        </div >
    );
}

export default PaymentSuccess